export enum OfferListMode {
  estateagency,
  estateagent,
  myestateagency,
  userlist,
  favorite,
  history,
  developerproject,
}
